var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgPrint = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M411,243h-2v-2a5,5,0,0,0-5-5h-8a5,5,0,0,0-5,5v2h-2a5,5,0,0,0-5,5v7a5,5,0,0,0,5,5h2v5a3,3,0,0,0,3,3h12a3,3,0,0,0,3-3v-5h2a5,5,0,0,0,5-5v-7A5,5,0,0,0,411,243Zm-18-2a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3v2H393Zm14,24a1,1,0,0,1-1,1H394a1,1,0,0,1-1-1v-9h14Zm7-10a3,3,0,0,1-3,3h-2v-2h2a1,1,0,0,0,0-2H389a1,1,0,0,0,0,2h2v2h-2a3,3,0,0,1-3-3v-7a3,3,0,0,1,3-3h22a3,3,0,0,1,3,3Zm-19,4a1,1,0,0,1,1-1h8a1,1,0,0,1,0,2h-8A1,1,0,0,1,395,259Zm0,4a1,1,0,0,1,1-1h4a1,1,0,0,1,0,2h-4A1,1,0,0,1,395,263Zm17-15a1,1,0,0,1-1,1h-2a1,1,0,0,1,0-2h2A1,1,0,0,1,412,248Z",
    transform: "translate(-376 -228)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/print.f17d3341.svg";
export { ForwardRef as ReactComponent };